import { useContext } from 'react';
import { AppContext, AppContextType } from '../contexts/AppContext';

const useAppContext = (): AppContextType => {
  return useContext(AppContext);
};

export default useAppContext;
